import TagsContent, { TagsContentProps } from './TagsContent';
import withPresenter from './TagsContent.presenter';
import withInteractor from './TagsContent.interactor';

export type { TagsContentProps };
export default withInteractor(withPresenter(TagsContent));
